import { Form } from 'formik';
import React from 'react';
import { ContributorSection } from '../../components/ContributorSection';
import { PamphletContributorFunctions } from './constants';
import { RecommendationBar } from '../../components/Shared';
import { useWritingForm } from '../../hooks/useWritingForm';
import { SourceType } from '../../types';
import { SECTION_TITLE, TestIds } from './constants';
import GenericSection from '../../components/GenericSection';
import { MoreOptionsSection } from '../../components/MoreOptions';
import { PRINT_SECTION_FIELDS } from './constants/fieldList';
import { PubMainTypeEnum } from '../../types';
var PamphletForm = function PamphletForm() {
  useWritingForm(SourceType.PAMPHLET);
  return /*#__PURE__*/React.createElement(Form, {
    "data-test": TestIds.PAMPHLET_FORM
  }, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: PamphletContributorFunctions
  }), /*#__PURE__*/React.createElement(GenericSection, {
    fieldList: PRINT_SECTION_FIELDS,
    name: PubMainTypeEnum.PUB_NONPERIODICAL,
    sectionTitle: SECTION_TITLE,
    "data-test": TestIds.PAMPHLET_PUB_INFO,
    selectedTab: ''
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default PamphletForm;